// Paleta de avatares (visual, determinístico). Igual à do GroupListItem.
const AVATAR_COLORS = ["#2F80ED", "#8B5CF6", "#8A94A6", "#2BC0AD", "#EC4899"];

// Iniciais das 2 primeiras palavras; '#' se vazio.
export const initials = (text) =>
    String(text || "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "#";

// URL da foto do grupo = identidade configurada da campanha (group_image), servida em /storage.
// Campanha-wide (propagada a todos os grupos). null quando não há imagem.
export const groupPhotoUrl = (campaign) =>
    campaign && campaign.group_image ? `${process.env.REACT_APP_LINK_API}/storage/${campaign.group_image}` : null;

// Cor determinística a partir de qualquer chave (string/número).
export const avatarColorFor = (key) => {
    const s = String(key == null ? "" : key);
    let hash = 0;
    for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};
